module.exports = __webpack_public_path__ + "static/media/ep2.7f32f9fc.png";